import { render, staticRenderFns } from "./JobCardModuleContent.vue?vue&type=template&id=3dedefa4&scoped=true"
import script from "./JobCardModuleContent.vue?vue&type=script&lang=js"
export * from "./JobCardModuleContent.vue?vue&type=script&lang=js"
import style0 from "./JobCardModuleContent.vue?vue&type=style&index=0&id=3dedefa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dedefa4",
  null
  
)

export default component.exports